export const ApplicationId = {
  TREK_VR: 0,
  DASHBOARD: 3,
};

export const UserStatusFilter = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  ALL: "all",
};
